module.exports = __webpack_public_path__ + "img/code.ab9c0293.png";